import ServerRequestUtil from '../utils/ServerRequestUtil';

/**
 * FT-002 AUBE Stake: ウォレットA情報・ステーク要求API
 */
export default new class {

    constructor() {
    }

    async getUserWallet(spinner = true) {
        return ServerRequestUtil.get('/api/app/user-wallet', {}, spinner);
    }

    /**
     * Keeps GlobalSpinner on (default): this POST is the one and only loading indicator of the
     * confirm flow. GlobalSpinner lives outside .app-module (z-index:2) so it paints on top of
     * the modal, which is what we want here — the modal's `submitting` state alone (button
     * label + disabled) is too subtle to read as "working". The follow-up refreshes fired from
     * the completion screen stay spinner-less on purpose so the user is not shown a second
     * loading for work they did not trigger.
     */
    async createStakeRequest({amount, plan, reference_uuid}) {
        return ServerRequestUtil.post('/api/app/aube-stake/requests', {amount, plan, reference_uuid});
    }

    async getStakeEstimatedGas() {
        return ServerRequestUtil.post('/api/app/user-wallet/gas-estimate', {currency: 'AUBE'}, false);
    }

    async getTransferEstimatedGas({currency, recipient_address, amount}) {
        const payload = {currency};
        if (recipient_address) {
            payload.recipient_address = recipient_address;
        }
        if (amount) {
            payload.amount = amount;
        }
        return ServerRequestUtil.post('/api/app/user-wallet/gas-estimate', payload, false);
    }

    async createTokenTransfer({currency, recipient_address, amount, send_email_code, reference_uuid}) {
        return ServerRequestUtil.post('/api/app/user-wallet/token-transfers', {
            currency,
            recipient_address,
            amount,
            send_email_code,
            reference_uuid,
        });
    }

    async createTokenTransferV2({currency, recipient_address, amount, reference_uuid}) {
        return ServerRequestUtil.post('/api/app/user-wallet/token-transfers-v2', {
            currency,
            recipient_address,
            amount,
            send_email_code: true,
            reference_uuid,
        });
    }

    async verifyTokenTransfer({transfer_id, verification_code}) {
        return ServerRequestUtil.post('/api/app/user-wallet/token-transfers/verify', {
            transfer_id,
            verification_code,
        });
    }

    async resendTransferVerifyCode({transfer_id}) {
        return ServerRequestUtil.post('/api/app/user-wallet/resend-verify-code', {
            transfer_id,
        });
    }

    /**
     * 通貨別ウォレット履歴（入金/送付/コントラクト実行）— ETH/AUBEタブで使用
     */
    async getWalletActivities({currency, page = 1, perPage = 20, spinner = true} = {}) {
        return ServerRequestUtil.get('/api/app/wallet/activities', {
            currency: currency,
            page: page,
            per_page: perPage,
        }, spinner);
    }

    /**
     * FT-001 Reward Claim: currency毎の UNCLAIMED 合計・withdrawal_ids スナップショット取得
     */
    async getClaimable(spinner = true) {
        return ServerRequestUtil.get('/api/app/user-wallet/reward-claims/claimable', {}, spinner);
    }

    /**
     * FT-001 Reward Claim: 指定 withdrawal_ids（単一 currency）に対するガス見積り
     */
    async getClaimGasEstimate({withdrawalIds}) {
        return ServerRequestUtil.post('/api/app/user-wallet/reward-claims/gas-estimate', {withdrawal_ids: withdrawalIds}, false);
    }

    /**
     * FT-001 Reward Claim: Unstake/報酬獲得の確定（EIP-712署名 + オンチェーン送信）
     * GlobalSpinner 無し — 完了モーダルがスピナーの show/hide で点滅しないようにする。
     * モーダル側の submitting 表示で進捗を伝える。
     */
    async submitRewardClaim({withdrawalIds}) {
        // Keeps GlobalSpinner on, same as createStakeRequest: this is the single loading of the
        // confirm flow; everything refreshed afterwards runs silently.
        return ServerRequestUtil.post('/api/app/user-wallet/reward-claims', {withdrawal_ids: withdrawalIds});
    }
}
